
<div class="dropdown">

  <a  *ngIf="gatePass.is_role_guardian"
      [routerLink]="['/guardian/groups/index',gatePass.user_id]"
      class="nav-link nav-main-white">
      <div class="d-none d-md-block"> <i class='fa fa-users'></i></div>
          <i class='fa fa-users d-md-none'></i>
          My Groups
  </a>

  </div>
